export default "__VITE_ASSET__CP196sNn__"